import LayoutWithSidebar from '../components/common/layoutWithSidebar';
import BillingHeader from '../components/Billing/BillingHeader';
import BillingTabs from '../components/Billing/BillingTabs';

const Billing = () => {
  return (
    <LayoutWithSidebar margin={2}>
      <BillingHeader />
      <BillingTabs />
    </LayoutWithSidebar>
  );
};

export default Billing;
